<template>
  <div
    class="col-12 col-md-6 col-lg-4 item-card"
    v-on="{ mouseenter: windowWidth > 1200 ? mouseenter : doNothing }"
    @mouseleave="mouseleave"
  >
    <div class="item-card-main-content">
      <div class="image-container item-card-header" :id="imgId">
        <img :src="product.imgsrc">
      </div>

      <div class="item-card-descr" :id="descrCardId">
        <div class="item-card-descr__content">
          <h3 class="item-card-descr__title" :id="descrCardTitleId">{{product.title}}</h3>
          <!-- <div class="item-card-descr__label item-card-descr__animated">Производитель</div> -->
          <div class="item-card-descr__text item-card-descr__animated">{{product.descr}}</div>
          <!--
          <div class="item-card-descr__label item-card-descr__animated">Описание</div>
          <div class="item-card-descr__text item-card-descr__animated">{{product.type}}</div>
          -->
          <div
            class="item-card-descr__img item-card-descr__animated"
            :style="{backgroundImage: 'url(' +  product.imgsrc2 + ')'}"
          ></div>
        </div>
      </div>

      <div class="item-card-footer">
        <div class="item-card-footer__title-wrap" :id="footerTitleId">
          <div class="item-card-footer__title">{{product.title}}</div>
          <div class="item-card-footer__price">{{product.price}}</div>
        </div>
        <div>
          <img class="item-card-footer__btn" src="@/assets/addBtn.png" @click="onBtnClick">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TimelineMax } from "gsap/TweenMax";

export default {
  name: "ItemCard",
  props: {
    product: Object
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      descrVisible: false,
      imgId: "item-card-img" + this.product.id,
      descrCardId: "item-card-descr" + this.product.id,
      descrCardTitleId: "item-card-descr__title" + this.product.id,
      footerTitleId: "item-card-footer-title" + this.product.id
    };
  },
  mounted() {
    window.addEventListener("resize", this.onWinResize, true);
  },
  methods: {
    mouseenter() {
      this.descrVisible = true;
      let tl = new TimelineMax();
      tl.addLabel("start")
        .to("#" + this.imgId, 0.6, { scale: 0.8, y: "-27%" }, "start")
        .to("#" + this.descrCardId, 0.5, { opacity: 1 }, "start")
        .to("#" + this.footerTitleId, 0.5, { opacity: 0 }, "start")
        .from("#" + this.descrCardTitleId, 0.4, { opacity: 0, y: 20 })
        .staggerFromTo(
          "#" + this.descrCardId + " .item-card-descr__animated",
          0.4,
          { opacity: 0, y: 10 },
          { opacity: 1, y: 0 },
          0.2
        );
    },
    mouseleave() {
      this.descrVisible = false;
      let tl = new TimelineMax();
      tl.addLabel("start")
        .to("#" + this.imgId, 0.8, { scale: 1, y: "0%" }, "start")
        .to("#" + this.descrCardId, 0.5, { opacity: 0 }, "start")
        .to("#" + this.footerTitleId, 0.5, { opacity: 1 }, "start");
    },
    onBtnClick(e) {
      this.descrVisible ? this.mouseleave() : this.mouseenter();
    },
    onWinResize() {
      this.windowWidth = window.innerWidth;
      //console.log(this.windowWidth);
    },
    doNothing() {}
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/styles/settings.scss";

.item-card {
  border: 1px solid $gray-color;
  overflow: hidden;
}
.item-card:hover {
  background-color: $card-hover-color;
}
.item-card-main-content {
  width: 100%;
  height: 100%;
  position: relative;
}

.item-card-descr__content {
  padding-bottom: 20px;
  margin: 40px auto 0;
}
.item-card-descr__title {
  font-size: 2.5rem;
}
.item-card-descr__label {
  color: $light-gray-color;
  font-size: 1.8rem;
  padding: 15px 0 5px;
}
.item-card-descr__text {
  font-size: 1.3rem;
  padding: 5px 0;
}
@media only screen and (max-width: 575px) {
  .item-card-descr__text {
    font-size: 1.2rem;
  }
}

.item-card-main-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.item-card-header img {
  margin: 80px auto;
}
.item-card-footer {
  width: 100%;
  padding: 15px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.item-card-footer__title {
  font-size: 2rem;
  font-weight: bold;
}
.item-card-footer__price {
  font-size: 1.5rem;
  color: $light-gray-color;
}
.item-card-footer__btn {
  cursor: pointer;
}

.item-card-descr {
  opacity: 0;
  overflow: hidden;

  position: absolute;
  bottom: 60px;
}
.item-card-descr__img {
  margin-top: 10px;
  width: 100%;
  height: 100px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}
</style>
